"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylesConfig = exports.componentConfig = void 0;
var componentConfig = exports.componentConfig = {
  label: {
    color: 'var(--color-global-black)',
    size: '1',
    tag: 'label',
    type: 'paragraph'
  },
  srLabel: {
    className: 'fuse-radio__sr-label'
  }
};
var inputHeight = '24px';
var inputWidth = '24px';
var stylesConfig = exports.stylesConfig = {
  input: {
    height: "calc(".concat(inputHeight, " - var(--border-width-s))"),
    // offset height by outline width
    width: "calc(".concat(inputWidth, " - var(--border-width-s))") // offset width by outline width
  },
  radioLabelBefore: {
    height: inputHeight,
    width: inputWidth
  }
};